<template>
    <Popover class="relative z-30" v-slot="{ open, close }">
        <PopoverButton class="inline-flex items-center gap-x-1 text-blue outline-none">
            <span class="uppercase md:hidden">{{ props.label }}</span>
            <h2 class="hidden! md:inline-block! font-header uppercase text-blue font-bold text-xl leading-none m-0! pr-2">{{ props.label }}</h2>
            <CalendarIcon class="size-4 md:size-6" aria-hidden="true" />
            <ChevronDownIcon class="size-4" aria-hidden="true" :class="{ 'rotate-180 transform': open }" />
        </PopoverButton>

        <transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0 translate-y-1"
            enter-to-class="translate-y-0"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="translate-y-0"
            leave-to-class="opacity-0 translate-y-1"
        >
            <PopoverPanel class="absolute left-1/2 z-10 mt-4 flex w-screen max-w-max -translate-x-1/2 bg-transparent px-4">
                <div class="w-screen max-w-xs flex flex-col rounded-3xl bg-blue before:hidden p-6 text-md shadow-lg">
                    <a
                        v-for="item in options"
                        :key="item.value"
                        @click.prevent="
                            selectValue(item.value);
                            close();
                        "
                        href="#"
                        :data-month="item.value"
                        class="text-white uppercase hover:underline! hover:decoration-1!"
                    >
                        {{ item.label }}
                    </a>
                </div>
            </PopoverPanel>
        </transition>
    </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { ChevronDownIcon, CalendarIcon } from "@heroicons/vue/20/solid";

const props = defineProps({
    label: {
        type: String,
        required: true,
    },
    modelValue: {
        type: String,
        default: "",
    },
    options: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits(["update:modelValue"]);

function selectValue(value) {
    emit("update:modelValue", value);
}
</script>
